module.exports = __webpack_public_path__ + "static/img/shengjing.1f75280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/shengjing.png
// module id = hWGD
// module chunks = 93